
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/namigi/avtor/[slug]",
      function () {
        return require("private-next-pages/namigi/avtor/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/namigi/avtor/[slug]"])
      });
    }
  